import EmployerAdd from '../pages/Admin/Employer/EmployerAdd';
import EmployersList from '../pages/Admin/Employer/EmployersList';
import EmployerDetail from '../pages/Admin/Employer/EmployerDetail';
import EmployeeList from '../pages/Admin/Employee/EmployeeList';
import EmployeeAdd from '../pages/Admin/Employee/EmployeeAdd';
import EmployeeAddTemporary from '../pages/Admin/Employee/EmployeeAddTemporary';
import AdvanceList from '../pages/Admin/Advances/AdvanceList';
import AdvanceBatches from '../pages/Admin/AdvanceBatches';
import SavingsBatches from '../pages/Admin/SavingsBatches';
import AdvanceBatchConfigurationList from '../pages/Admin/AdvanceBatches/AdvanceBatchConfigurationList';
import SubscriptionBatchConfigurationList from '../pages/Admin/AdvanceBatches/SubscriptionBatchConfigurationList';
import MessagesList from '../pages/Admin/Messages/MessagesList';
import EmployeeDetail from '../pages/Admin/Employee/EmployeeDetail';

// Login
import { Auth0Login, Auth0LoginCallback } from '../pages/Admin/Login';

// EmployerAdmin
import SmsList from '../pages/Admin/SMS/SmsList';
import UserList from '../pages/Admin/User/UserList';
import UserDetail from '../pages/Admin/User/UserDetail';
import UserAdd from '../pages/Admin/User/UserAdd';
import TARoleList from '../pages/Admin/TARoles/TARoleList';
import TARoleDetail from '../pages/Admin/TARoles/TARoleDetail';
import RegistrationList from '../pages/Admin/Registrations/RegistrationList';
import ColdRegistrationAttempts from '../pages/Admin/Registrations/ColdRegistrationAttempts';
import AdvanceDetail from '../pages/Admin/Advances/AdvanceDetail';

// Education Questions
import EducationQuestions from '../pages/Admin/EducationQuestions';
import EditEducationQuestionView from '../pages/Admin/EditEducationQuestionView';
import AddEducationQuestionView from '../pages/Admin/AddEducationQuestion';
import BulkUploadUsers from '../pages/Admin/User/BulkUploadUsers';
import UserPermissions from '../pages/Admin/User/UserPermissions';
import UserAuditLog from '../pages/Admin/User/UserAuditLog';
import SupportTicketList from '../pages/Admin/SupportTickets/SupportTicketList';
import AdvancePaymentFiles from '../pages/Admin/AdvancePaymentFiles';
import EmployerReconsPage from '../pages/Admin/EmployerRecons/EmployerReconsPage';

import Tools from '../pages/Admin/Tools';
import MergeProfiles from '../pages/Admin/Tools/MergeProfiles';
import EmployeeBlockDates from '../pages/Admin/Advances/EmployeeBlockDates';
import LeadsList from '../pages/Admin/Leads/LeadsList';

// Security
import SecurityPage from '../pages/Admin/Security/SecurityPage';
// Identity-verification session detail — opened from the Identity
// Verifications tab on Security, back-nav lands on Security. The
// person-level view lives on the EmployeeDetail page now (Verification
// + Identification Documents tabs).
import SessionDetailPage from '../pages/Admin/Security/SessionDetailPage';

// Verification Admin
import PolicyDetailPage from '../pages/Admin/VerificationAdmin/PolicyDetailPage';

// Import AppTypes
import { PageRoute } from '../types/AppTypes';

const routes = [
  // Employers Routes
  {
    path: PageRoute.Employers,
    name: 'Employers',
    icon: 'fas fa-user',
    component: EmployersList,
    layout: '/admin',
  },
  {
    path: PageRoute.EmployerAdd,
    name: 'Employer Add',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployerAdd,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.EmployerDetail,
    name: 'Employer Detail',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployerDetail,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.EmployerRecons,
    name: 'Employer Recons',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployerReconsPage,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.EmployerEmployees,
    name: 'Employer Edit',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployeeList,
    layout: '/admin',
    invisible: true,
  },
  // Employee Routes
  {
    path: PageRoute.Employees,
    name: 'Employees',
    icon: 'fas fa-users',
    component: EmployeeList,
    layout: '/admin',
  },
  {
    path: PageRoute.EmployeeAdd,
    name: 'Employee Add',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployeeAdd,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.EmployeeAddTemporary,
    name: 'Employee Add Temporary',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployeeAddTemporary,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.EmployeeDetail,
    name: 'Employee Detail',
    icon: 'ni ni-tv-2 text-primary',
    component: EmployeeDetail,
    layout: '/admin',
    invisible: true,
  },
  // Advance Routes
  {
    path: PageRoute.Advances,
    name: 'Advances',
    icon: 'fas fa-money-bill',
    component: AdvanceList,
    layout: '/admin',
    count: true,
    countName: 'advances',
    secondCount: true,
    secondCountName: 'risky_advances',
  },
  // Advance Routes
  {
    path: PageRoute.BlockDates,
    name: 'Block Dates',
    icon: 'fas fa-money-bill',
    component: EmployeeBlockDates,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.AdvanceDetail,
    name: 'Advance Edit',
    icon: 'ni ni-key-25 text-info',
    component: AdvanceDetail,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.AdvanceBatches,
    name: 'Advance Batches',
    icon: 'fa fa-tasks',
    component: AdvanceBatches,
    layout: '/admin',
    invisible: false,
  },
  {
    path: PageRoute.SavingsBatches,
    name: 'Savings Batches',
    icon: 'fa fa-piggy-bank',
    component: SavingsBatches,
    layout: '/admin',
    invisible: false,
  },
  {
    path: PageRoute.AdvancePaymentFiles,
    name: 'Advance Payment Files',
    component: AdvancePaymentFiles,
    layout: '/admin',
    icon: 'fas fa-file-invoice-dollar',
    invisible: false,
  },
  {
    path: PageRoute.AdvanceBatchConfigurations,
    name: 'Advance Batches Config',
    component: AdvanceBatchConfigurationList,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.SubscriptionBatchConfigurations,
    name: 'Subscription Batches Config',
    component: SubscriptionBatchConfigurationList,
    layout: '/admin',
    invisible: true,
  },
  // Messages
  {
    path: PageRoute.Messages,
    name: 'Messages',
    icon: 'fas fa-comments',
    component: MessagesList,
    layout: '/admin',
  },
  {
    path: PageRoute.SmsLogs,
    name: 'SMS logs',
    icon: 'fas fa-sms',
    component: SmsList,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.Registrations,
    name: 'Registrations',
    icon: 'fas fa-user-plus',
    component: RegistrationList,
    layout: '/admin',
    count: true,
    countName: 'registrations',
  },
  {
    path: PageRoute.ColdRegistrationAttempt,
    name: 'Cold Registration Attempts',
    icon: 'fas fa-user-plus',
    component: ColdRegistrationAttempts,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.Tickets,
    name: 'Support Tickets',
    icon: 'fas fa-user-plus',
    component: SupportTicketList,
    layout: '/admin',
    count: true,
    countName: 'supportTickets',
  },
  {
    path: PageRoute.Leads,
    name: 'Lead tracking',
    icon: 'fas fa-user-plus',
    component: LeadsList,
    layout: '/admin',
  },
  {
    path: PageRoute.MergeProfiles,
    name: 'Merge Profiles',
    icon: 'fas fa-align-center',
    component: MergeProfiles,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.UserBulkUpload,
    name: 'Bulk Add Users',
    icon: 'fas fa-user-shield',
    component: BulkUploadUsers,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.UserAdd,
    name: 'Users',
    icon: 'fas fa-user-shield',
    component: UserAdd,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.UserPermissions,
    name: 'Users',
    icon: 'fas fa-user-shield',
    component: UserPermissions,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.UserLogs,
    name: 'User logs',
    icon: 'fas fa-user-shield',
    component: UserAuditLog,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.Users,
    name: 'Users',
    icon: 'fas fa-user-shield',
    component: UserList,
    layout: '/admin',
  },
  {
    path: PageRoute.Tools,
    name: 'Tools',
    icon: 'fa fa-support',
    component: Tools,
    layout: '/admin',
  },
  {
    path: PageRoute.Security,
    name: 'Security',
    icon: 'fas fa-shield-alt',
    component: SecurityPage,
    layout: '/admin',
  },
  {
    path: PageRoute.UserDetail,
    name: 'Users',
    icon: 'fas fa-user-shield',
    component: UserDetail,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.TARoleDetail,
    name: 'T&A Role Detail',
    icon: 'fas fa-user-lock',
    component: TARoleDetail,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.TARoles,
    name: 'T&A Roles',
    icon: 'fas fa-user-lock',
    component: TARoleList,
    layout: '/admin',
  },
  {
    path: PageRoute.Login,
    name: 'Login',
    icon: 'ni ni-key-25 text-info',
    component: Auth0Login,
    layout: '/auth',
    invisible: true,
  },
  {
    path: PageRoute.Callback,
    name: 'Auth0 Callback',
    icon: 'ni ni-key-25 text-info',
    component: Auth0LoginCallback,
    layout: '/auth',
    invisible: true,
  },
  {
    path: PageRoute.EducationQuestions,
    name: 'Education Questions',
    icon: 'fa fa-graduation-cap',
    component: EducationQuestions,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.AddEducationQuestion,
    name: 'Add Education Question',
    icon: 'fas fa-users',
    component: AddEducationQuestionView,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.EditEducationQuestion,
    name: 'Edit Education Question',
    icon: 'fas fa-users',
    component: EditEducationQuestionView,
    layout: '/admin',
    invisible: true,
  },

  // ---------------------------------------------------------------------
  // Verification — policy + document detail pages (reached from the Security
  // tab and the per-employee Verification view).
  // ---------------------------------------------------------------------
  {
    path: PageRoute.VerificationPolicyDetail,
    name: 'Policy Detail',
    component: PolicyDetailPage,
    layout: '/admin',
    invisible: true,
  },
  {
    path: PageRoute.SecuritySessionDetail,
    name: 'Session Detail',
    component: SessionDetailPage,
    layout: '/admin',
    invisible: true,
  },
];
export default routes;
